import { createContext, useContext } from 'react';

const CONTEXT_ELEMENT_ID = 'js-template-context';
const Context = createContext(
  JSON.parse(
    document.getElementById(CONTEXT_ELEMENT_ID)?.textContent || '{}',
  ) || {},
);
export default function useTemplateContext() {
  return useContext(Context);
}
